import { useRouter } from "next/router"

import { FulfillmentType } from "@models/order"
import { useFulfillmentOptions } from "hooks/useFulfillmentOptions"
import { useCart } from "providers/cart-provider"

export function usePickup() {
  const { cart, setFulfillmentType } = useCart()
  const router = useRouter()
  const { setPendingSelection } = useFulfillmentOptions({})

  const handleSelectPickup = async (storeSlug: string) => {
    if (!cart.data) {
      return
    }

    setPendingSelection("pickup")

    await setFulfillmentType.mutateAsync(
      {
        fulfillmentType: FulfillmentType.pickup,
        isCurbside: false,
        curbsidePickupVehicleMakeModel: "",
        curbsidePickupVehicleColor: "",
        curbsidePickupVehicleNotes: "",
      },
      {
        onSuccess: () => {
          setPendingSelection(null)
          router.push(`/${storeSlug}`)
        },
      },
    )
  }

  return {
    handleSelectPickup,
  }
}
